import { render, staticRenderFns } from "./testimonials-reviews.vue?vue&type=template&id=2bb7a932"
import script from "./testimonials-reviews.vue?vue&type=script&lang=js"
export * from "./testimonials-reviews.vue?vue&type=script&lang=js"
import style0 from "./testimonials-reviews.vue?vue&type=style&index=0&id=2bb7a932&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports